import Component from '../colorz/Component';

import device from '../colorz/utils/device';

module.exports = class Lightbox extends Component {
  onInit( el, args) {
    // Initializations
    this.onOpen   = this.onOpen.bind( this );
    this.onClose  = this.onClose.bind( this );

    this.el       = el;
    this.content = this.el.querySelector('.popin__content');
    this.wrapper = this.el.querySelector('.popin__wrapper');
    this.cross = this.el.querySelector('.popin__content .close');
    this.timeout = null;
  }

  onReady() {
    this.el.addEventListener( device.pointerdown, this.onOpen );
    this.cross.addEventListener( device.pointerdown, this.onClose );
  }

  onOpen() {
    document.body.classList.add('is-popin-open');
    this.wrapper.style.display = 'block';

    clearTimeout( this.timeout );

    requestAnimationFrame( () => {
      this.wrapper.classList.add('is-fade-in');
    });
  }

  onClose() {
    this.wrapper.classList.remove('is-fade-in');

    this.timeout = setTimeout( () => {
      this.wrapper.style.display = 'none';
    }, 300);
  }
}